import React from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

// Components
import Layout from "./components/Layout";
import Routes from "./Routes";

//
import UserMiddlewares from "./store/middlewares/UserMiddlewares";
import UserActions from "./store/actions/UserActions";

const App = () => {
  const initialAuthChecked = useSelector((state) => state.user.initialChecked);
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("xml-podcast-auth-token");
    if (token) {
      return dispatch(UserMiddlewares.initialLogin(token));
    } else {
      return dispatch(UserActions.initialLoginNoToken());
    }
  }, []);

  if (!initialAuthChecked) {
    return null;
  }

  return (
    <Layout>
      <Routes />
    </Layout>
  );
};

export default App;
